import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Redirect if already logged in
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        navigate('/welcome');
      }
    });
    
    return () => unsubscribe();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, formData.email, formData.password);
      // Redirect to dashboard after successful login
      navigate('/welcome');
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Header */}
        <div className="login-header">
          <div className="login-logo-circle">
            <span className="login-logo-text">KG</span>
          </div>
          <h1 className="login-company-name">Kajja Galleries</h1>
          <p className="login-subtitle">Training Portal</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-form-group">
            <label className="login-form-label">Email Address</label>
            <input
              type="email"
              name="email"
              required
              value={formData.email}
              onChange={handleInputChange}
              className="login-form-input"
              placeholder="Enter your email"
            />
          </div>

          <div className="login-form-group">
            <label className="login-form-label">Password</label>
            <input
              type="password"
              name="password"
              required
              value={formData.password}
              onChange={handleInputChange}
              className="login-form-input"
              placeholder="Enter your password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="login-submit-btn"
          >
            {loading ? (
              <>
                <span className="login-loading"></span>
                Signing In...
              </>
            ) : (
              'Login to Account'
            )}
          </button>
        </form>

        {/* Links */}
        <div className="login-links">
          <button 
            onClick={() => navigate('/signup')} 
            className="login-link"
            type="button"
          >
            Don't have an account? Sign up
          </button>
        </div>

        {/* Footer */}
        <div className="login-footer">
          © 2024 Kajja Galleries. Secure access only.
        </div>
      </div>
    </div>
  );
};

export default Login;